import { ReactElement, useState } from 'react';

import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { SmallInternship } from './types';

const INTERNSHIP_STRINGS = appStrings.modules.nugget.internship;

type NuggetInternshipSmallProps = Readonly<{
  variant: SmallInternship;
  contentSize?: 'SMALL' | 'LARGE';
}>;

export function NuggetInternshipSmall({
  variant,
  contentSize = 'LARGE',
}: NuggetInternshipSmallProps): ReactElement {
  const [isLogoLinkValid, setIsLogoLinkValid] = useState(false);

  const titleStyles = contentSize === 'SMALL' ? smallTextStyle : textStyle;

  return (
    <Box sx={containerStyle}>
      <Box sx={textWrapperStyle}>
        {variant.internshipInfo.role_type && (
          <Typography variant="body1" sx={titleStyles}>
            <em>{INTERNSHIP_STRINGS.QUICK_LOOK.type}</em> {variant.internshipInfo.role_type}
          </Typography>
        )}
        {variant.internshipInfo.career_path_name && (
          <Typography variant="body1" sx={titleStyles}>
            <em>{INTERNSHIP_STRINGS.QUICK_LOOK.path}</em> {variant.internshipInfo.career_path_name}
          </Typography>
        )}
        {variant.internshipInfo.location && (
          <Typography variant="body1" sx={titleStyles}>
            <em>{INTERNSHIP_STRINGS.QUICK_LOOK.location}</em> {variant.internshipInfo.location}
          </Typography>
        )}
        {variant.internshipInfo.apply_by_date && (
          <Typography variant="body1" sx={titleStyles}>
            <em>{INTERNSHIP_STRINGS.QUICK_LOOK.deadline}</em>{' '}
            {new Date(variant.internshipInfo.apply_by_date).toLocaleDateString()}
          </Typography>
        )}
      </Box>
      {variant.internshipInfo.logo_link && (
        <Box
          component="img"
          src={variant.internshipInfo.logo_link}
          alt="Internship"
          sx={{ ...logoImageStyle, display: isLogoLinkValid ? 'block' : 'none' }}
          onLoad={() => setIsLogoLinkValid(true)}
          onError={() => setIsLogoLinkValid(false)}
        />
      )}
    </Box>
  );
}

const textStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '20px',
  mt: 1,
  textOverflow: 'ellipsis',
  display: 'block',
};

const textWrapperStyle: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

const smallTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '18px',
  mt: 0.5,
};

const containerStyle: SxProps<Theme> = {
  mt: 2,
  flexDirection: { xs: 'row', sm: 'column', md: 'row' },
  display: 'flex',
  justifyContent: 'space-between',
};

const logoImageStyle: SxProps<Theme> = {
  maxWidth: '83px',
  minWidth: '83px',
  maxHeight: '83px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  alignSelf: 'flex-end',
  mt: 2,
  ml: 4,
};
